"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDdIncreaseExplainerLi = exports.StyledMoneyImage = exports.StyledRadiatorImage = exports.StyledUsageImage = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../../../shared/core/utils/styles");
var images_1 = require("../../images");
var styleSvg = function (svgIcon) { return (0, styled_components_1.default)(svgIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  min-height: 4rem;\n"], ["\n  ", "\n  min-height: 4rem;\n"])), (0, styles_1.svgWidth)('4rem', 32, 32)); };
exports.StyledUsageImage = styleSvg(images_1.UsageImage);
exports.StyledRadiatorImage = styleSvg(images_1.RadiatorImage);
exports.StyledMoneyImage = styleSvg(images_1.MoneyImage);
exports.StyledDdIncreaseExplainerLi = styled_components_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var templateObject_1, templateObject_2;
